import { render, staticRenderFns } from "./shipmentOrderList.vue?vue&type=template&id=2a5834b1&"
import script from "./shipmentOrderList.vue?vue&type=script&lang=js&"
export * from "./shipmentOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports